<script>
    import { format, locale } from "svelte-i18n";
    import assetService from "../../asset/service.js";
    import Version from '../../../components/version.svelte';
    import snapshotService from "../service.js";
    import dayjs from "dayjs";
    import relativeTime from 'dayjs/plugin/relativeTime';
    import localizedFormat from 'dayjs/plugin/localizedFormat';
    import 'dayjs/locale/es';
    import 'dayjs/locale/en';


    dayjs.locale($locale);
    dayjs.extend(relativeTime);
    dayjs.extend(localizedFormat);

    let { snapshotsComparison } = $props();

    let is_downloading = $state(false);
    let isDropdownOpen = $state(false);

    const updateDownloadingStatus = () => is_downloading = !is_downloading;

    const getComparisonIcon = (num) => {
        if(num < 0) return 'fas fa-long-arrow-alt-down'
        if(num > 0) return 'fas fa-long-arrow-alt-up'
        return 'fas fa-equals'
    }

    const orderCountByLevel = (count) => {
        return {
            critical: count.critical,
            high: count.high,
            medium: count.medium,
            low: count.low
        }
    }

    const getFormattedDate = (dateString) => {
        return dayjs(dateString).format("YYYY/MM/DD");
    }

    const downloadComparisonReport = async (base_snapshot, comparison_snapshot, lang) => {
        isDropdownOpen = false;
        updateDownloadingStatus();
        let base_snapshot_cr_at = getFormattedDate(base_snapshot.created_at);
        let comparison_snapshot_cr_at = getFormattedDate(comparison_snapshot.created_at);

        let file_name = lang == "en" ? "vulseek.comparison-report__" : "vulseek.reporte-comparativo__" ;
        file_name = file_name + `${base_snapshot_cr_at}_${comparison_snapshot_cr_at}.html`

        let file = await snapshotService.getComparisonReport(base_snapshot.id, comparison_snapshot.id, lang);
        if (file) {
            const fileBlob = await file.blob();
            const fileUrl = URL.createObjectURL(fileBlob);
            const anchor = document.createElement("a");
            anchor.href = fileUrl;
            anchor.download = file_name;
            document.body.appendChild(anchor);
            anchor.click();
            document.body.removeChild(anchor);

            URL.revokeObjectURL(fileUrl);
        }
        updateDownloadingStatus();
    }

    // clickOutside Svelte action for the dropdown
    const clickOutside = (node, callback) => {
        const handleClick = (event) => {
            if (node && !node.contains(event.target) && !event.defaultPrevented) {
                callback();
            }
        };
        document.addEventListener("click", handleClick, true);
        return {
            destroy() {
                document.removeEventListener("click", handleClick, true);
            },
        };
    };
</script>

<!-- MODAL -->
<div
    class="modal fade"
    id="snapshot-comparison-modal"
    tabindex="-1"
    aria-hidden="true"
    data-backdrop="static"
    data-keyboard="false"
>
    <div class="modal-dialog modal-xl">
        <div class="modal-content">
            <div class="modal-header">
                <h3 class="modal-title">
                    {$format("page.snapshot.compare_snapshots_title")}
                </h3>
                <!-- Native Bootstrap 5 dismiss handles the closing flawlessly -->
                <button
                    type="button"
                    class="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                ></button>
            </div>
            <div class="modal-body">
                {#if Object.keys(snapshotsComparison.data).length > 0}
                    <div class="table-responsive">
                        <table class="table table-striped" style="min-height: 500px;">
                            <thead>
                                <tr>
                                    <th></th>
                                    <th>{$format("asset.plural")}</th>
                                    <th>{$format("finding.plural")}</th>
                                    <th>{$format("vulnerability.plural")}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>{dayjs(snapshotsComparison.data.snapshot_2.created_at).format("YYYY/MM/DD")} ({$format("page.snapshot.comparison_snapshot")})</td>
                                    <td>
                                        <div class="d-flex" style="gap: 5px;">
                                            {#each Object.entries(snapshotsComparison.data.assets_count_by_kind) as [key, value] (crypto.randomUUID())}
                                                <span><i class={assetService.icons[key]} title={$format(`asset.kind.${key}.plural`)}></i> {value.newSnapshotValue}</span>
                                            {/each}
                                        </div>
                                    </td>
                                    <td>
                                        <div class="d-flex" style="gap: 5px;">
                                            {#each Object.entries(orderCountByLevel(snapshotsComparison.data.findings_count_by_level)) as [level, value] (crypto.randomUUID())}
                                                <span class="{"cvss-badge cvss-badge-small " + `cvss-${level}`}" title={$format(`vulnerability.severity.${level}`)}>{value ? value.newSnapshotValue : 0}</span>
                                            {/each}
                                        </div>
                                    </td>
                                    <td>
                                        <div class="d-flex" style="gap: 5px;">
                                            {#each Object.entries(orderCountByLevel(snapshotsComparison.data.vulnerabilities_count_by_level)) as [level, value] (crypto.randomUUID())}
                                                <span class="{"cvss-badge cvss-badge-small " + `cvss-${level}`}" title={$format(`vulnerability.severity.${level}`)}>{value ? value.newSnapshotValue : 0}</span>
                                            {/each}
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>{dayjs(snapshotsComparison.data.snapshot_1.created_at).format("YYYY/MM/DD")} ({$format("page.snapshot.base_snapshot")})</td>
                                    <td>
                                        <div class="d-flex" style="gap: 5px;">
                                            {#each Object.entries(snapshotsComparison.data.assets_count_by_kind) as [key, value] (crypto.randomUUID())}
                                                <span><i class={assetService.icons[key]} title={$format(`asset.kind.${key}.plural`)}></i> {value.oldSnapshotValue}</span>
                                            {/each}
                                        </div>
                                    </td>
                                    <td>
                                        <div class="d-flex" style="gap: 5px;">
                                            {#each Object.entries(orderCountByLevel(snapshotsComparison.data.findings_count_by_level)) as [level, value] (crypto.randomUUID())}
                                                <span class="{"cvss-badge cvss-badge-small " + `cvss-${level}`}" title={$format(`vulnerability.severity.${level}`)}>{value ? value.oldSnapshotValue : 0}</span>
                                            {/each}
                                        </div>
                                    </td>
                                    <td>
                                        <div class="d-flex" style="gap: 5px;">
                                            {#each Object.entries(orderCountByLevel(snapshotsComparison.data.vulnerabilities_count_by_level)) as [level, value] (crypto.randomUUID())}
                                                <span class="{"cvss-badge cvss-badge-small " + `cvss-${level}`}" title={$format(`vulnerability.severity.${level}`)}>{value ? value.oldSnapshotValue : 0}</span>
                                            {/each}
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>{$format("page.snapshot.diff")}:</td>
                                    <td>
                                        <div class="d-flex" style="gap: 5px;">
                                            {#each Object.entries(snapshotsComparison.data.assets_count_by_kind) as [key, value] (crypto.randomUUID())}
                                                <span><i class={assetService.icons[key]} title={$format(`asset.kind.${key}.plural`)}></i> <div class="d-flex align-items-center"><i class={getComparisonIcon(value.diff)}></i>{value.diff != 0 ? Math.abs(value.diff) : ""}</div></span>
                                            {/each}
                                        </div>
                                    </td>
                                    <td>
                                        <div class="d-flex" style="gap: 5px;">
                                            {#each Object.entries(orderCountByLevel(snapshotsComparison.data.findings_count_by_level)) as [level, value] (crypto.randomUUID())}
                                                <!-- {#if value} -->
                                                    <span class="{"cvss-badge cvss-badge-small " + `cvss-${level}`}" title={$format(`vulnerability.severity.${level}`)}><div class="d-flex align-items-center"><i class={getComparisonIcon(value.diff)}></i>{value.diff != 0 ? Math.abs(value.diff) : ""}</div></span>
                                                <!-- {/if} -->
                                            {/each}

                                        </div>
                                    </td>
                                    <td>
                                        <div class="d-flex" style="gap: 5px;">
                                            {#each Object.entries(orderCountByLevel(snapshotsComparison.data.vulnerabilities_count_by_level)) as [level, value] (crypto.randomUUID())}
                                                <!-- {#if value} -->
                                                    <span class="{"cvss-badge cvss-badge-small " + `cvss-${level}`}" title={$format(`vulnerability.severity.${level}`)}><div class="d-flex align-items-center"><i class={getComparisonIcon(value.diff)}></i>{value.diff != 0 ? Math.abs(value.diff) : ""}</div></span>
                                                <!-- {/if} -->
                                            {/each}

                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                {/if}
            </div>
            <div class="modal-footer justify-content-start">
                <div class="btn-group dropdown" use:clickOutside={() => isDropdownOpen = false}>
                    <button id="SnapshotsComparisonReportBtn" type="button" class="btn btn-primary" onclick={() => isDropdownOpen = !isDropdownOpen}>
                        {#if !is_downloading}
                            {$format("page.snapshot.comparison_report_btn")}
                        {:else}
                            <i class="fa-sync-alt fa-spin fas"></i>
                        {/if}
                    </button>
                    {#if !is_downloading}
                        <button type="button" class="btn btn-primary dropdown-toggle dropdown-icon" onclick={() => isDropdownOpen = !isDropdownOpen}>
                        <span class="visually-hidden">Toggle Dropdown</span>
                        </button>
                    {/if}
                    <div class="dropdown-menu" class:show={isDropdownOpen} role="menu">
                      <a class="dropdown-item" href="#" onclick={(e)=>{e.preventDefault(); downloadComparisonReport(snapshotsComparison.data.snapshot_1, snapshotsComparison.data.snapshot_2, "es");}}>{$format("spanish")}</a>
                      <a class="dropdown-item" href="#" onclick={(e)=>{e.preventDefault(); downloadComparisonReport(snapshotsComparison.data.snapshot_1, snapshotsComparison.data.snapshot_2, "en");}}>{$format("english")}</a>
                    </div>
                  </div>
            </div>
        </div>
    </div> <!-- /.modal-content -->
</div> <!-- /.modal-dialog -->

<!-- END MODAL-->

<style>
    .modal {
        font-size: 1.25rem;
    }
    .modal-body {
        padding: 0 !important;
        min-height: 500px;
    }
    th {
        text-align: center;
    }
    span {
        display: flex;
        flex-direction: column;
        align-items: center;
        flex: 1;
    }
    span.cvss-badge{
        margin: 0 !important;
        width: 3.25em;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    table td {
        vertical-align: middle;
    }
    td div.d-flex {
        justify-content: center;
    }
    i {
        font-size: 1rem;
    }
    .cvss-badge i {
        color: white;
        margin-right: 2px;
    }
    .fas.fa-equals {
        margin-top: 8px;
        margin-bottom: 7px;
    }
</style>